import {Component, EventEmitter, Input, Output} from '@angular/core';
import {ModalService} from "../../../../services/modal.service";

@Component({
  selector: 'app-delete-group-virtual-cash-dialog',
  templateUrl: './delete-group-virtual-cash-dialog.component.html',
  styleUrls: ['./delete-group-virtual-cash-dialog.component.scss']
})
export class DeleteGroupVirtualCashDialogComponent {
  @Input() deleteGroup!: any[]
  @Output() deleteEvent: EventEmitter<void> = new EventEmitter<void>()
  protected readonly close = close;

  constructor(
    private modalService: ModalService
  ) {
  }


  closeModal() {
    this.modalService.isModalOpen$.next(false)
  }

  deleteCash() {
    this.deleteEvent.emit()
  }
}
